import React, { useContext, useMemo } from 'react'
import { useSelector } from 'react-redux'

import StepForm from '../../../../../../features/components/Forms/StepForm'
import NameStep from '../Steps/NameStep'
import FacebookPageStep from '../Steps/FacebookPageStep'
import StatusStep from '../Steps/StatusStep'
import UrlTagsStep from '../Steps/UrlTagsStep'
import WarningStep from '../Steps/WarningStep'
import ExistingPostStep from '../Steps/ExistingPostStep'
import FacebookExistingPostPreview from '../../../../../../features/components/FacebookPreviews/FacebookExistingPostPreview'
import LinkStep from '../Steps/LinkStep'
import CallToActionStep from '../Steps/ActionStep'

import { useCreateFacebookAd } from '../hooks/useCreateFacebookAd'

import { accessibleSocialPagesSelector } from '../../../../../../modules/selectors/socialAccounts'

import { AdFacebookCreateContext } from '../../../../formsContexts/AdFacebookCreateFormContextProvider'

import { CALL_TO_ACTION, CLICK_THROUGH_LINK, FORMAT_EXISTING_POST } from '../../../fields'

const ExistingPostRoute = ({
  FormRouteSelector,
  eventSourceStep,
  isInternalAdCreation,
  selectedPixelPassedFromOutside,
  allowSendPixel,
  selectedApplicationId,
  ...formProps
}) => {
  const facebookPages = useSelector(accessibleSocialPagesSelector)

  const { preselectedValues } = useContext(AdFacebookCreateContext)

  const { isAdSetEndDateInThePast, showAsStory, purifiedFormik, isDomainValidating } = useCreateFacebookAd({
    isInternalAdCreation,
    selectedPixelPassedFromOutside,
    allowSendPixel,
    formatOption: FORMAT_EXISTING_POST
  })

  const { values } = purifiedFormik

  const steps = useMemo(
    () => [
      {
        component: <WarningStep />,
        show: isAdSetEndDateInThePast
      },
      {
        component: FormRouteSelector,
        show: !showAsStory
      },
      {
        component: <FacebookPageStep />,
        show: facebookPages.length !== 1
      },
      {
        component: <ExistingPostStep />,
        show: true
      },
      {
        component: <NameStep />,
        show: true
      },
      {
        component: <LinkStep />,
        show: !preselectedValues[CLICK_THROUGH_LINK]
      },
      {
        component: <CallToActionStep />,
        show: !preselectedValues[CALL_TO_ACTION]
      },
      eventSourceStep,
      {
        component: (
          <UrlTagsStep
            adPreview={<FacebookExistingPostPreview values={values} />}
            selectedApplicationId={selectedApplicationId}
          />
        ),
        show: true
      },
      {
        component: <StatusStep />,
        show: true
      }
    ],
    [
      FormRouteSelector,
      eventSourceStep,
      showAsStory,
      isAdSetEndDateInThePast,
      values,
      facebookPages,
      preselectedValues,
      selectedApplicationId
    ]
  )

  return <StepForm steps={steps} formik={purifiedFormik} {...formProps} isSubmitDataLoading={isDomainValidating} />
}

export default ExistingPostRoute
